import React from 'react';
import classnames from 'classnames';

export type Size = 'xs' | 'sm' | 'md' | 'lg';
export type ImageType = 'bell' | 'cards' | 'images' | 'people' | 'questions' | 'reminders';

const imageMap: Record<ImageType, string> = {
  bell: require('./bell.png'),
  cards: require('./cards.png'),
  images: require('./images.png'),
  people: require('./people.png'),
  questions: require('./questions.png'),
  reminders: require('./reminders.png')
};

export interface Props {
  image: ImageType;
  size?: Size;
  title: string;
  description: string;
  className?: string;
}

const sizeClasses = {
  xs: 'w-[72px] h-[72px] min-w-[72px] mb-[13px]',
  sm: 'w-[128px] h-[128px] min-w-[128px] mb-[18px]',
  md: 'w-[186px] h-[186px] min-w-[186px] mb-[24px]',
  lg: 'w-[256px] h-[256px] min-w-[256px] mb-[31px]'
};

const Placeholder: React.FC<Props> = ({ image, size = 'md', title, description, className }) => (
  <div className={classnames('flex flex-col items-center', className)}>
    <img src={imageMap[image]} className={classnames(sizeClasses[size])} alt={title} />
    <h3 className="text-lg font-semibold text-center mb-2">{title}</h3>
    <p className="text-sm text-black-faded text-center">{description}</p>
  </div>
);

export default Placeholder;
